/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Start_GroupInputs */

const en_header_start_group = /** @type {(inputs: Header_Start_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a local group`)
};

/**
* | output |
* | --- |
* | "Start a local group" |
*
* @param {Header_Start_GroupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_start_group = /** @type {((inputs?: Header_Start_GroupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Start_GroupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_start_group(inputs)
});